import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { usePersistedFiltering } from '../../../contexts/FilterContext';
import { getPath, roles, userAllowed } from '../../../helpers/utils';
import { FILTER_KEYS, SIMS_PAGE_URL_MAPPING, SOLUTION_TYPE } from '../../../helpers/const';

export function useSimPageSavedTabNavigationRedirect() {
    const { getFiltersForPage } = usePersistedFiltering();
    const { enterpriseId, solutionType, roles: userRoles } = useSelector((state) => state.auth);
    const isEp5g = useMemo(() => solutionType === SOLUTION_TYPE.EP5G, [solutionType]);

    const savedTab = getFiltersForPage(FILTER_KEYS.SIM.CURRENT_TAB);
    const isSimsPageAllowed = userAllowed(userRoles, [roles.VIEW_SUBSCRIBERS]);
    const isSimsBackupsAllowed = userAllowed(userRoles, [roles.VIEW_BACKUPS]);
    const isRestorePageAllowed = isEp5g && userAllowed(userRoles, [roles.VIEW_BACKUPS]);
    const isDyrectorySyncPageAllowed = userAllowed(userRoles, [roles.VIEW_DIRECTORY_SYNC_SCIM, roles.MANAGE_SUBSCRIBERS], false);
    const isAuditAllowed = isEp5g && userAllowed(userRoles, [roles.VIEW_BACKUPS]);
    const isAnySimsPageAllowed = isSimsPageAllowed || isSimsBackupsAllowed || isRestorePageAllowed || isDyrectorySyncPageAllowed || isAuditAllowed;

    const getDefaultPath = () => {
        return isSimsPageAllowed
            ? getPath(enterpriseId, SIMS_PAGE_URL_MAPPING.sims)
            : isSimsBackupsAllowed
            ? getPath(enterpriseId, SIMS_PAGE_URL_MAPPING.backup)
            : '/';
    };

    const getSavedSimsTabPath = () => {
        switch (savedTab) {
            case SIMS_PAGE_URL_MAPPING.sims: {
                return isSimsPageAllowed ? getPath(enterpriseId, SIMS_PAGE_URL_MAPPING.sims) : getDefaultPath();
            }
            case SIMS_PAGE_URL_MAPPING.backup: {
                return isSimsBackupsAllowed ? getPath(enterpriseId, SIMS_PAGE_URL_MAPPING.backup) : getDefaultPath();
            }
            case SIMS_PAGE_URL_MAPPING.directorySync: {
                return isDyrectorySyncPageAllowed ? getPath(enterpriseId, SIMS_PAGE_URL_MAPPING.directorySync) : getDefaultPath();
            }
            case SIMS_PAGE_URL_MAPPING.audit: {
                return isAuditAllowed ? getPath(enterpriseId, SIMS_PAGE_URL_MAPPING.audit) : getDefaultPath();
            }
            case SIMS_PAGE_URL_MAPPING.restore: {
                return isRestorePageAllowed ? getPath(enterpriseId, SIMS_PAGE_URL_MAPPING.restore) : getDefaultPath();
            }
            default: {
                return getDefaultPath();
            }
        }
    };

    return {
        isAnySimsPageAllowed,
        getSavedSimsTabPath
    };
}
